<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><strong>Contents</strong></h1>
<p class="toc-chap"><a href="#/006_Chapter01#ch-1">1.<span class="toc">Do the Stuff You Don’t Want to Do</span></a></p>
<p class="toc-chap2"><a href="#/007_Chapter02#ch-2">2.<span class="toc">Learn How to Shoulder Someone Else’s Dreams</span></a></p>
<p class="toc-chap3"><span href="#/008_Chapter03#ch-3" title="Link target outside of Sample">3.<span class="toc">Diapers Don’t Have a Shelf Life (AKA: Shit Happens)</span></span></p>
<p class="toc-chap4"><span href="#/009_Chapter04#ch-4" title="Link target outside of Sample">4.<span class="toc">Be Willing to Be Inconsistent</span></span></p>
<p class="toc-chap5"><span href="#/010_Chapter05#ch-5" title="Link target outside of Sample">5.<span class="toc">Go to the Funeral</span></span></p>
<p class="toc-chap6"><span href="#/011_Chapter06#ch-6" title="Link target outside of Sample">6.<span class="toc">Sometimes Quitting Is the Best Way Forward</span></span></p>
<p class="toc-chap7"><span href="#/012_Chapter07#ch-7" title="Link target outside of Sample">7.<span class="toc">There Is No Secret to Survival</span></span></p>
<p class="toc-chap7"><span href="#/013_Chapter08#ch-8" title="Link target outside of Sample">8.<span class="toc">Bet Your Life</span></span></p>
<p class="toc-chap7"><span href="#/014_Chapter09#ch-9" title="Link target outside of Sample">9.<span class="toc">Live Your Own Lie—and Do It Honestly</span></span></p>
<p class="toc-chap7"><span href="#/015_Chapter10#ch-10" title="Link target outside of Sample">10.<span class="toc">Count Your Traumas</span></span></p>
<p class="toc-chap6"><span href="#/016_Chapter11#ch-11" title="Link target outside of Sample">11.<span class="toc">Why Not Me?</span></span></p>
<p class="toc-chap5"><span href="#/017_Chapter12#ch-12" title="Link target outside of Sample">12.<span class="toc">Don’t Be Afraid to Be Boring</span></span></p>
<p class="toc-chap4"><span href="#/018_Chapter13#ch-13" title="Link target outside of Sample">13.<span class="toc">Don’t Worry about Doing the Right Thing (Because You Probably Already Know What It Is)</span></span></p>
<p class="toc-chap3"><span href="#/019_Chapter14#ch-14" title="Link target outside of Sample">14.<span class="toc">Don’t <em>Leave</em> a Legacy</span></span></p>
<p class="toc-bm"><span href="#/020_Epilogue#bm-1" title="Link target outside of Sample"><em>Epilogue</em></span></p>
<p class="toc-bm1"><span href="#/021_Ack#bm-2" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?76f3d81f